interface RotatingImageProps {
  images: string[];
  imageIndex: number;
  label?: string;
  labelColor?: string;
  altText?: string;
  className?: string;
  hoverBorderColor?: string;
  activeGlowColor?: string;
  showGlow?: boolean;
}

const RotatingImage = ({
  images,
  imageIndex,
  className = "w-10 h-10 rounded-lg",
}: RotatingImageProps) => {
  const src = images[imageIndex % images.length];

  return (
    <div className="inline-block align-middle mx-1">
      <div
        className={`relative ${className} shadow-md overflow-hidden z-10 border-2 border-transparent`}
      >
        <img
          src={src}
          alt=""
          loading="eager"
          fetchPriority="auto"
          decoding="async"
          className="w-full h-full object-cover"
        />
      </div>
    </div>
  );
};

export default RotatingImage;
